import { render, staticRenderFns } from "./SingleClientTransactions.vue?vue&type=template&id=698ab5a8&"
import script from "./SingleClientTransactions.vue?vue&type=script&lang=js&"
export * from "./SingleClientTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports